module.exports = __webpack_public_path__ + "static/media/delete.fc50723d.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WatchList/delete.png
// module id = 1071
// module chunks = 0